import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { Link as RouterLink } from 'react-router-dom';
import AdminIcon from '@components/icons/AdminLink.svg';

export const AdminLink = () => {
  const { me } = useAuthContext();

  if (!me?.roles) {
    return null;
  }

  const isVsAdmin = me.roles.includes('ROLE_VS_ADMIN');
  if (!isVsAdmin) {
    return null;
  }
  return (
    <RouterLink
      title="Admin Panel"
      to={routes.adminDashboard.make()}
      className="inline-flex min-h-11 min-w-11 items-center justify-center text-[var(--color-text-muted)] font-normal text-base leading-none underline rounded-[5px] hover:bg-[var(--color-danger)] hover:text-[var(--color-surface)]"
    >
      <AdminIcon />
    </RouterLink>
  );
};
